import script from "./ClassicChooseRoleStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicChooseRoleStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicChooseRoleStep.vue?vue&type=style&index=0&id=ba926e4c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba926e4c"]])

export default __exports__